import React from 'react';
import LinksAppContainer from "./LinksAppContainer";
import {useBreakpoints} from "@nutastic/nutastic-react-app";

//TODO: refactor and move to react-app project, build in standard support in NuEngine
const LinksAppWrapper = ({ backgroundRender, ...rest }) => {
    const componentClass = "linksAppWrapper";
    const { md: isLargeScreen } = useBreakpoints();
    const linksAppRender = <LinksAppContainer {...rest} />;

    return <React.Fragment>
        { isLargeScreen && backgroundRender }
        { isLargeScreen ? <div className={componentClass}>{ linksAppRender }</div> : linksAppRender }
    </React.Fragment>;
};

export default LinksAppWrapper;
